import {Payload} from '../../../payload/payload';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';
import {HttpClient, HttpContext, HttpHeaders, HttpParams} from '@angular/common/http';
import {AbstractActionService} from '../action/abstractAction.service';
import {IDownloadActionService} from './iDownloadAction.service';

export abstract class AbstractDownloadActionService<P extends Payload> extends AbstractActionService<P, any>
    implements IDownloadActionService<P>{


    protected constructor(entityName: string,
                          actionName: string,
                          customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                          httpClient: HttpClient) {
        super(entityName, actionName, customizeHttpUrlGenerator, httpClient);
    }

    buildOptions(payload: P): { headers?: HttpHeaders | { [p: string]: string | string[] };
        context?: HttpContext; observe?: 'body'; params?: HttpParams | {
            [p: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
        reportProgress?: boolean; responseType?: 'json'; withCredentials?: boolean } {
        return {responseType: 'blob' as 'json'};
    }
}
